module.exports = __webpack_public_path__ + "img/anne_h.8ca70705.png";